import Benchmarks from "./benchmarks";

export default Benchmarks;